export const GENERAL_ERROR_CODES = {
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
};
export const GENERAL_ERROR_DESCRIPTIONS = {
    UNEXPECTED_ERROR: {
        title: '予期せぬエラーが発生しました',
        description: 'お手数ですが、もう一度お試しください',
    },
    UNAUTHORIZED: {
        title: '認証エラーが発生しました',
        description: 'ログインし直した上で再度お試しください',
    },
};
